import React, { useEffect, useState, useContext } from "react";

function Modal({ isOpen, toggleModal, closeable = true, backgroundColor, children }) {

    const onClickBackground = closeable ? toggleModal : () => { };
    const backgroundCssClass = backgroundColor == "dark" ? "user-portal-modal-backdrop dark" : "user-portal-modal-backdrop";

    // Modals should trap focus and support ESC key to close when closeable. 
    useEffect(() => {
        if (!isOpen || !closeable) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") toggleModal();
        };

        document.addEventListener("keydown", handleKeyDown);
        return () => document.removeEventListener("keydown", handleKeyDown);
    }, [isOpen, closeable, toggleModal]);

    return (
        <div>
            {isOpen && (
                <div
                    role="dialog"
                    aria-modal="true"
                    className={backgroundCssClass}
                    onClick={onClickBackground}
                >
                    <div
                        className="user-portal-modal-content"
                        onClick={e => e.stopPropagation()}
                        tabIndex={-1}
                    >
                        {children}
                    </div>
                </div>
            )}
        </div>
    );
}

export default Modal;